import { NavLink, Link } from 'react-router-dom';
import { useState } from 'react';
import logo_familymart from '../assets/images/logo-familymart.png'

const menuItems = [
  { name: 'home', label: 'Home', path: '/' },
  { name: 'promo', label: 'Promo', path: '/promo' },
  // { name: 'download', label: 'Download App', path: '/famigo-download' },
  { name: 'events', label: 'Events', path: '/events' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed bg-sky-400 text-white py-2 px-[10px] md:px-[50px] lg:px-[70px] xl:px-[100px] w-full z-10">
      <div className="flex justify-between items-center">
        {/* Logo */}
        <Link to="/">
          <img
            src={logo_familymart}
            className="w-[175px] md:w-[260px]"
            alt="FamilyMart Indonesia"
          />
        </Link>

        {/* Hamburger Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-[4px]"
          aria-label="Toggle Menu"
        >
          <span className="w-6 h-[2px] bg-white"></span>
          <span className="w-6 h-[2px] bg-white"></span>
          <span className="w-6 h-[2px] bg-white"></span>
        </button>

        {/* Menu Items */}
        <nav
          className={`
            absolute md:static top-full left-0 w-full md:w-auto bg-sky-400 md:bg-transparent 
            flex-col md:flex-row md:flex items-center 
            ${menuOpen ? 'flex' : 'hidden'} md:flex 
            gap-2 md:gap-8 p-4 md:p-0
          `}
        >
          {menuItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setMenuOpen(false)} // auto-close on click
              className={({ isActive }) =>
                `flex items-center justify-start md:justify-center rounded-lg py-2 px-4 lg:px-12 text-sm md:text-base 
   w-full md:w-auto ${isActive ? 'bg-blue-primary md:bg-blue-primary' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
